var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-col",
    {
      staticClass: "healthyCommunityMainBlock my-3 px-2",
      attrs: { cols: "12", xl: "4" },
      on: { click: _vm.click }
    },
    [
      _c(
        "base-card",
        {
          staticClass: "healthyCommunityBlockHeight pointer",
          attrs: { titleClass: "healthyCommunityTitle" }
        },
        [
          _c("base-icon", {
            class: {
              "d-inline-block": _vm.$store.state.isMobile,
              "mr-2": _vm.$store.state.isMobile
            },
            attrs: {
              src: _vm.img,
              alt: "",
              height: _vm.$store.state.isMobile ? "30" : "42",
              width: _vm.$store.state.isMobile ? "30" : "42",
              color: "blue"
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "neu-card-title my-3" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c("p", {
            staticClass: "description-block-healthy-community",
            domProps: { innerHTML: _vm._s(_vm.description) }
          }),
          _vm._v(" "),
          _vm.blockEnabled
            ? _c(
                "div",
                [
                  _vm.showPendingPushNotificationsInLanding(_vm.sectionId) &&
                  !_vm.soonLabel
                    ? _c(
                        "p",
                        {
                          staticClass: "my-3",
                          staticStyle: { "margin-bottom": "0 !important" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.goSection(_vm.sectionId)
                            }
                          }
                        },
                        [
                          _c(
                            "base-button",
                            {
                              staticClass:
                                "btnReadNotificationsHealthyCommunity",
                              attrs: { white: "" }
                            },
                            [
                              _c("b-icon-bell", { staticClass: "pointer" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getPendingPushNotificationsMessage(
                                      _vm.sectionId
                                    )
                                  )
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.showPendingPushNotificationsInLanding(_vm.sectionId) &&
                  !_vm.soonLabel
                    ? _c(
                        "base-button",
                        {
                          staticClass: "btnAccessHealthyCommunity my-3",
                          attrs: { white: "" }
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.$t("accessBtn")))])]
                      )
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "b-badge",
                    { staticClass: "mt-3", attrs: { variant: "info" } },
                    [_vm._v(_vm._s(_vm.$t("only-subscriptors")))]
                  )
                ],
                1
              ),
          _vm._v(" "),
          _vm.soonLabel
            ? _c(
                "p",
                { staticStyle: { "margin-bottom": "0" } },
                [
                  _c(
                    "b-badge",
                    {
                      staticClass: "mt-3 soon-label-healthy-community",
                      class: { blink: _vm.blinkSoonLabelActive },
                      attrs: { variant: "primary" }
                    },
                    [_vm._v(_vm._s(_vm.$t("soon-label")))]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ea826ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ea826ce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/healthy-community/HealthyCommunityVerticalCard.vue
// module id = 3645
// module chunks = 7